import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'

Vue.config.productionTip = false

Vue.use(VueMeta,{
    refreshOnceOnNavigation: true
})

// Vue.mixin({
//     beforeCreate() {
//         if (this.$options.watch) {
//         Object.entries(this.$options.watch).forEach(([watcherKey, func]) => {
//                 this.$options.watch[watcherKey] = new Proxy(func, {
//                 apply(target, thisArg) {
//                     console.log(`Called watcher ${target.name} on component ${thisArg.$options.name}`);
//                 },
//             });
//         });
//         }
//     },
// });

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
        // here I check that click was outside the el and his children
        if (!(el == event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
        }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

Vue.filter('format_thousands', ( value, decimals=null, houses=2 ) => {
    if(!value) return false
    let rounded = Math.round(value * 100) / 100;

    if(decimals != null) rounded = parseFloat(rounded).toFixed(houses)

    return rounded
        .toString()
        .replace(".", ",")
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
})

new Vue({
    router,
    store,
    render: h => h(App)
})
.$mount('#app')
